<template>
  <div>
    <div class="row reading-form-container">
      <div class="small-12 columns">
        <button class="button-green" @click="addReadingMaterailQuestion">
          Add Reading
        </button>
      </div>
      <div class="small-3 columns">Name</div>
      <div class="small-9 columns">
        <input v-model="name" type="text" class="input-box-course-creators" />
      </div>
      <div class="small-3 columns">Tags</div>
      <div class="small-9 columns" style="position:relative;z-index:10000">
        <VueSelect
          v-model="selectedTags"
          :options="tagOptions"
          label="name"
          multiple
        />
      </div>
      <div class="small-3 columns">Reading Time</div>
      <div class="small-9 columns">{{ readingTime }} seconds</div>
    </div>
    <div class="row">
      <div class="small-12 columns">
        <button class="button-yellow" @click="togglePreview">
          <span v-if="previewOn">Hide</span>
          <span v-if="!previewOn">Show</span> <span>Editor</span>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="small-12 columns">
        <div v-if="previewOn" class="small-6 columns">
          <markdown-editor
            ref="editormarkdown"
            v-model="content"
            @input="saveToLocalStorage"
            @imageAdded="catchImageAddedEvent"
          />
        </div>
        <div :class="previewOn ? 'small-6 columns' : 'small-12 columns'">
          <div style="padding:16px;" class="markdown-body">
            <vue-markdown :source="decodeAndRenderMarkdown()" />
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="(attachment, i) in attachments"
          :key="i"
          class="small-2 columns"
        >
          <div
            class="reading-attachment-image"
            :style="{
              'background-image': 'url(' + attachment.public_url + ')',
            }"
          />
          <span>{{ attachment }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import { mapGetters, mapActions } from "vuex"
import VueMarkdown from "vue-markdown"
import siteConfig from "@/utils/siteConfig"
import readingTimeEstimator from "@/utils/readingTimeEstimator"
// / This is a modified version of markdown editor to function with custom tools

import markdownEditor from "@/components/questions/MarkdownReadingEditor"

export default {
  components: { markdownEditor, VueMarkdown, VueSelect },
  data() {
    return {
      content: JSON.parse(localStorage.getItem("readingMaterial")) || "",
      name: "",
      is_required: false,
      tags: [],
      attachments: [],
      getReadingObject: {},
      previewOn: true,
      readingTime: 0,
      qtags: [],
      selectedTags: [],
      tagOptions: [],
    }
  },
  computed: {
    ...mapGetters("module", ["getCurrentEditingReadingObject"]),
  },
  mounted() {
    // Get reading element
    // Populate tags
    this.populateTags()

    window.Prism.highlightAll()
    this.$nextTick(() => {
      window.Prism.highlightAll()
    })
  },
  methods: {
    ...mapActions("module", ["SET_CURRENT_EDITING_READING_OBJECT"]),
    togglePreview() {
      this.previewOn = !this.previewOn
    },
    saveToLocalStorage(string) {
      localStorage.setItem("readingMaterial", JSON.stringify(string))
    },
    populateTags() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}qtags/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const tags = res.data.items
        this.tagOptions = tags.map(item => ({ id: item.id, name: item.name }))
      })
    },
    addNewTag(tag) {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}qtags/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { name: tag, attachments: "" },
      }).then(res => {
        const { id } = res.data
        this.axios({
          method: "get",
          url: `${siteConfig.siteURL}qtags/${id}`,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
          },
          // eslint-disable-next-line no-shadow
        }).then(res => {
          const itemTag = res.data.data
          const newTagToAdd = {}
          newTagToAdd.id = itemTag.id
          newTagToAdd.name = itemTag.name
          this.selectedTags.push(newTagToAdd)
          this.populateTags()
        })
      })
    },
    decodeAndRenderMarkdown() {
      this.readingTime = readingTimeEstimator.calculate(
        this.content,
        this.attachments.length || 0
      )
      return this.content.replace(/(\[\[.*?\]\])/g, item => {
        for (let i = 0; i < this.attachments.length; i++) {
          if (this.attachments[i].id === item.slice(2, item.length - 2)) {
            return ` ![](${this.attachments[i].public_url})`
          }
        }
        return ""
      })
    },
    checkIfIdIsPartofAttachments(id, objectsArray) {
      for (let i = 0; i < objectsArray.length; i++) {
        if (id === objectsArray[i].id) {
          return true
        }
      }
      return false
    },
    removeDuplicateAttachments() {
      const { attachments } = this
      const finalObjects = []
      for (let i = 0; i < attachments.length; i++) {
        if (
          !this.checkIfIdIsPartofAttachments(attachments[i].id, finalObjects)
        ) {
          // check if id is part of our new array that stores unique id'ed objects
          finalObjects.push(attachments[i])
        }
      }
      return finalObjects
    },
    updateAttachmentsBeforeSubmit() {
      const finalAttachments = this.attachments

      let strings = this.content.match(/(\[\[.*?\]\])/g)
      if (!strings) {
        return []
      }
      strings = strings.map(item => item.slice(2, item.length - 2)) || []
      if (this.attachments.length === 0) {
        return []
      }
      for (let i = 0; i < this.attachments.length; i++) {
        for (let j = 0; j < strings.length; j++) {
          if (strings[j] === this.attachments[i].id) {
            finalAttachments.push(this.attachments[i])
          }
        }
        return this.removeDuplicateAttachments(finalAttachments)
      }
      return []
    },
    catchImageAddedEvent(data) {
      const content = data.encodedString
      this.attachments = data.attachments
      const readingObjectContent = this.getCurrentEditingReadingObject
      readingObjectContent.content = content
      this.content = data.encodedString
      this.SET_CURRENT_EDITING_READING_OBJECT(readingObjectContent)
    },
    getDeletedTags() {
      const deletedTags = []
      for (let i = 0; i < this.qtags.length; i++) {
        if (
          !this.findElementInArray(
            this.qtags[i].name,
            this.selectedTags.map(item => item.name)
          )
        ) {
          deletedTags.push(this.qtags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < deletedTags.length; i++) {
        finalTags.push(deletedTags[i].id)
      }
      return finalTags
    },
    getAddedTags() {
      const addedTags = []

      for (let i = 0; i < this.selectedTags.length; i++) {
        if (
          !this.findElementInArray(
            this.selectedTags[i].name,
            this.qtags.map(item => item.name)
          )
        ) {
          addedTags.push(this.selectedTags[i])
        }
      }
      const finalTags = []
      for (let i = 0; i < addedTags.length; i++) {
        finalTags.push(addedTags[i].id)
      }
      return finalTags
    },
    findElementInArray(element, array) {
      for (let i = 0; i < array.length; i++) {
        if (array[i] === element) {
          return true
        }
      }
      return false
    },
    addReadingMaterailQuestion() {
      // let newAttachments = this.$refs.editormarkdown.getAttachments()
      // this.attachments = newAttachments
      // ///
      if (this.name.length <= 1) {
        alert("Please make sure your name is valid, need a lengthier name")
        return
      }
      this.attachments = this.updateAttachmentsBeforeSubmit() || []
      const dataObj = {
        answers: {},
        content: this.content,
        tries: 0,
        points: 0,
        name: this.name,
        is_required: this.is_required,
        type: 3, // / 3 is READING
        item_cursor: 0,
        is_dependent_ids: "[]",
        ops_qtags_unlink: this.getDeletedTags(),
        ops_qtags: this.getAddedTags(),
        attachments: this.attachments,
        reading_time: this.readingTime,
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}questions/`,
        data: dataObj,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.$router.push("/reading/")
      })
    },
  },
}
</script>

<style>
.reading-attachment-image {
  width: 200px;
  height: 200px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}
.reading-form-container {
  margin-bottom: 20px;
}
.CodeMirror-scroll {
  min-height: 380px !important;
}
.CodeMirror {
  min-height: 380px !important;
}
</style>
